export default __webpack_public_path__ + "static/media/Bronzefury War Wolf.d1bd0bef.jpg";